"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyStateExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/empty-state/examples/index.ts';
var EmptyStateExample = /** @class */ (function () {
    function EmptyStateExample() {
        this.hasIcon = true;
        this.hasHeader = true;
        this.hasContent = true;
        this.fill = true;
    }
    EmptyStateExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.EmptyState, {
                icon: this.hasIcon ? _1.Icons.ARCHIVE : undefined,
                header: this.hasHeader && 'No search results found.',
                content: this.hasContent && (0, mithril_1.default)(_1.Input, {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SEARCH }),
                    placeholder: 'Search results...'
                }),
                fill: this.fill
            })
        ]);
    };
    EmptyStateExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasIcon,
                label: 'Icon',
                onchange: function () { return _this.hasIcon = !_this.hasIcon; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasHeader,
                label: 'Header',
                onchange: function () { return _this.hasHeader = !_this.hasHeader; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasContent,
                label: 'Content',
                onchange: function () { return _this.hasContent = !_this.hasContent; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fill,
                label: 'Fill',
                onchange: function () { return _this.fill = !_this.fill; }
            })
        ];
    };
    return EmptyStateExample;
}());
exports.EmptyStateExample = EmptyStateExample;
